import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ArrowLeft, Download, Printer, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useBackClose } from "@/lib/useBackClose";

/** Voorstel 28 C: één documentweergave op volledig scherm met terugknop; geopend via window-event 'bpt-open-pdf' ({url, titel}). */
export default function PdfViewer() {
  const [doc, setDoc] = useState(null);
  useEffect(() => {
    const h = (e) => setDoc(e.detail);
    window.addEventListener("bpt-open-pdf", h);
    return () => window.removeEventListener("bpt-open-pdf", h);
  }, []);
  useBackClose(!!doc, () => setDoc(null));
  if (!doc) return null;
  const sluit = () => setDoc(null);
  return createPortal(
    <div className="fixed inset-0 z-[200] bg-slate-900 flex flex-col" style={{ pointerEvents: "auto" }} data-testid="pdf-viewer">
      <div className="h-12 flex items-center gap-2 px-2 text-white bg-slate-950 safe-x">
        <Button size="sm" variant="ghost" className="text-white hover:bg-slate-800 h-10 min-w-[44px]" onClick={sluit} data-testid="pdf-viewer-terug"><ArrowLeft className="w-5 h-5 mr-1" />Terug</Button>
        <span className="truncate text-sm flex-1">{doc.titel || "Document"}</span>
        <a href={doc.url} download className="h-10 min-w-[44px] inline-flex items-center justify-center rounded hover:bg-slate-800" title="Downloaden" data-testid="pdf-viewer-download"><Download className="w-5 h-5" /></a>
        <button onClick={() => { const w = document.getElementById("pdf-viewer-frame")?.contentWindow; try { w?.focus(); w?.print(); } catch { window.open(doc.url, "_blank"); } }} className="h-10 min-w-[44px] inline-flex items-center justify-center rounded hover:bg-slate-800" title="Printen" data-testid="pdf-viewer-print"><Printer className="w-5 h-5" /></button>
        <a href={doc.url} target="_blank" rel="noreferrer" className="h-10 min-w-[44px] inline-flex items-center justify-center rounded hover:bg-slate-800" title="Openen in andere app" data-testid="pdf-viewer-extern"><ExternalLink className="w-5 h-5" /></a>
      </div>
      <iframe id="pdf-viewer-frame" src={doc.url} title={doc.titel || "Document"} className="flex-1 w-full bg-white" data-testid="pdf-viewer-frame" />
    </div>,
    document.body
  );
}
